class SideForm {
    constructor() {
        const formOn = document.querySelector('.formOn');
        if (!formOn) return;

        this.formBtn = document.querySelector('.btn-form');
        this.closeBtn = document.querySelector('.close-btn');
        this.modalForm = document.querySelector('.modal-form');
        this.overlay = document.querySelector('.overlay');

        this.bindEvents();
    }

    openForm() {
        this.modalForm.classList.add('open');
        this.openTimeline();
    }

    closeForm() {
        this.tl.reverse();
    }

    bindEvents() {
        this.formBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.openForm();
        });

        this.closeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.closeForm();
        });

        this.overlay.addEventListener('click', (e) => {
            e.preventDefault();
            this.closeForm();
        });

    }

    openTimeline() {
        this.tl = gsap.timeline();

        this.tl.to('.modal-container', {pointerEvents: 'unset', duration: "0.5", ease: "power2.inOut"})
            .to('.btn-form', {transform: 'translateY(100%)', autoAlpha:0}, "-=0.5")
            .to('.modal-form', {transform: 'translateX(0%)', autoAlpha:1, duration: "0.5", ease: "power2.inOut"}, "-=0.5")
            .to('.overlay', {autoAlpha: 1, duration: "0.5", ease: "power2.inOut"}, "-=0.5");
    }
}

